import { SearchSortEvent } from './SearchSortEvent';
import { searchSortSchema } from './SearchSortSchema';

export const searchSortToEvent = (sortOrder: string) => {
  const event: SearchSortEvent = {
    schema: searchSortSchema.ref,
    data: {
      sort_order: sortOrder,
    },
  };

  return event;
};
